import { type IncomingPayment, getPhoneNumber, getDocument, getCountry } from '@tectonics/prs/incoming-payment';
import { getSafeCountryFromCode } from '@tectonics/commons/country/country';
import { getAddress } from '@tectonics/prs/address';
import { getZipcodeNormalizer } from './zipcode';
import { normalizeCustomerDocument } from './document';

export function normalizeCustomerIncomingPayment<T extends IncomingPayment>(incomingPayment: T): T {
  const address = getAddress(incomingPayment);
  const rawPhoneNumber = getPhoneNumber(incomingPayment);
  const countryCode = getCountry(incomingPayment);
  const country = getSafeCountryFromCode(countryCode);
  const documentNormalizer = country.customerForm.documentNormalizer ?? normalizeCustomerDocument;

  const phoneNumberConfig = country.customerForm.phoneNumber;
  const normalizedPhoneNumber = (phoneNumberConfig && phoneNumberConfig.normalizer(rawPhoneNumber)) || rawPhoneNumber;

  const zipcode = address.zipcode || '';
  const zipcodeNormalizer = getZipcodeNormalizer(countryCode);

  return {
    ...incomingPayment,
    zipcode: zipcodeNormalizer(zipcode),
    phone_number: normalizedPhoneNumber,
    document: documentNormalizer(getDocument(incomingPayment)),
  };
}
